import { cn } from '@dialogueconsulting/sked-ui/lib/utils'

import { SkedLogo } from 'Icons'

function PoweredBySked({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      data-testid="powered_by_sked"
      // cn-merge so a className passed by a `styled(PoweredBySked)` wrapper
      // (preview / calendar / IG grid / mobile footers) augments these base
      // classes instead of overriding them — the override was dropping the
      // svg width constraint and rendering the logo at native size (SKE-3803).
      className={cn('flex items-center gap-2 [&_svg]:w-[27px]', className)}
      {...props}
    >
      <SkedLogo />
      <span className="text-xs font-bold text-neutral-200">
        Powered by Sked Social
      </span>
    </div>
  )
}

export default PoweredBySked
